<!-- Delete Confirmation Dialog-->
<ui-dialog
    size="small"
    [open]="isDeleteAutomationEmailSettingDialogOpen"
    (closing)="closeDeleteAutomationEmailSettingDialog()"
    header="{{ 'applicant-tracker.deleteAutomaticEmail' | appTranslate }}"
>
    <p>{{ 'applicant-tracker.movingForwardApplicantsWillNoLongerReceiveEmailsWhenTheyApply' | appTranslate }}</p>
    <p class="margin-top-1">{{ 'applicant-tracker.areYouSureYouWantToDeleteYourAutomaticEmail' | appTranslate }}</p>

    <ui-dialog-footer>
        <ui-button type="ghost" (click)="closeDeleteAutomationEmailSettingDialog()">{{
            'applicant-tracker.cancel' | appTranslate
        }}</ui-button>
        <ui-button type="danger" (click)="onDelete()">{{ 'delete' | appTranslate }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <ng-container *ngIf="automatedEmailSettings">
        <app-header title="{{ 'applicant-tracker.editAutomaticEmail' | appTranslate }}" [back]="true"></app-header>

        <div class="ui layout">
            <div class="content">
                <div class="ui segment">
                    <app-recruiting-automated-email-settings-form
                        [automatedEmailSettings]="automatedEmailSettings"
                        #automatedEmailSettingsForm
                    ></app-recruiting-automated-email-settings-form>

                    <div class="flex">
                        <div>
                            <ui-button type="danger" (click)="openDeleteAutomationEmailSettingDialog()"
                                >{{ 'applicant-tracker.deleteAutomaticEmail' | appTranslate }}
                            </ui-button>
                        </div>
                        <div class="margin-left-auto">
                            <ui-button type="ghost" (click)="onCancel()">{{ 'cancel' | appTranslate }}</ui-button>
                            <ui-button type="primary" (click)="onSave(automatedEmailSettingsForm)">{{
                                'save' | appTranslate
                            }}</ui-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sidebar">
                <app-customization-tokens></app-customization-tokens>
            </div>
        </div>
    </ng-container>
</div>
